import React, { useCallback, useEffect, useState } from "react";
import useStyles from "./styles";
import Paper from "@material-ui/core/Paper";
import { useParams } from "react-router-dom";
import { checkDocument, checkDocumentOpts, getDocument } from "./api";
import ActReconciliationMain from "./components/ActReconciliationMain";
import { ThemeProvider, Dialog, Typography, CircularProgress } from "@material-ui/core";
import themeMaterialUI from "./theme";
import ConfirmDialog from "./components/ConfirmDialog";
import PasswordDialog from "./components/PasswordDialog";
import RejectDialog from "./components/RejectDialog";

const CrmReport = () => {
  const { hash } = useParams();
  const cl = useStyles();
  const [state, setState] = useState({
    doctorPart: false,
    debt: false,
    rejectNote: '',
    rejectDialog: false,
    data: null,
    dialog: false,
    check: false,
    password: sessionStorage.getItem('partnerPassword'+hash) || '',
    dialogData: {
      f1: '',
      f2: ''
    },
    l: false,
    e: false,
  });
 

  const handleCheckPassword = useCallback(async () => {
    if (state.password && !state.l && !state.check) {
      try {
      setState((p) => ({
        ...p,
        l: true,
      }))
      const check = await checkDocument(hash)

      const opts = await checkDocumentOpts(hash)//[]//['debt', 'doctorPart']                              //past here options from server

      setState((p) => ({
        ...p,
        doctorPart: opts.includes('doctorPart'),
        debt: opts.includes('debt'),
        check,
        l: false,
      }));
    } catch (e) {
      sessionStorage.removeItem('partnerPassword'+hash)
      console.error(e);
      setState((p) => ({
        ...p,
        e: true,
        password: '',
        l: false,
      }));
    }
    }

  }, [hash, state.password]);

  useEffect(() => {
    handleCheckPassword();
  }, [handleCheckPassword]);

  const handleGetData = useCallback(async () => {
    try {
      if (!state.e && !state.l && !state.data && hash) {
        let check
        let data = []
        setState((p) => ({
          ...p,
          l: true,
        }));
        check = await checkDocument(hash)
        try {
          data = await getDocument(hash);
      } catch (e) {
          console.error(e);
          sessionStorage.removeItem('partnerPassword'+hash)

      setState((p) => ({
        ...p,
        l: false,
        password: '',
        e: true
      }));
      }

        setState((p) => ({
          ...p,
          data,
          l: false,
          check
        }));
      }
    } catch (e) {
      console.error(e);
      sessionStorage.removeItem('partnerPassword'+hash)

      setState((p) => ({
        ...p,
        l: false,
        password: '',
        e: true
      }));
    }
  }, [hash, state]);

  useEffect(() => {
    handleGetData();
  }, [handleGetData]);

  useEffect(() => {
    if (state.data && state.data.status === 2 && !state.dialog) {
      setState(p=>({
        ...p,
        dialog: true
      }))
    }
  }, [state?.data?.status]);

  return (<ThemeProvider theme={themeMaterialUI}>
    {!!state.password ? <>
    <Paper elevation={1} className={cl.root}>
      {state.data && !state.l && (
        <ActReconciliationMain data={state.data?.detail?.editedData} handleState={[state, setState]} detail={state.data.detail}/>
      )}
    </Paper>
    <ConfirmDialog handleState={[state, setState]} hash={hash}/>
    <RejectDialog handleState={[state, setState]} hash={hash}/>
    </>
    : !state.l && <PasswordDialog handleState={[state, setState]} hash={hash}/>}
    {state.l && <div style={{
      width: '100%', 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
      }}>
        <CircularProgress />
      </div>}
  </ThemeProvider>);
};

export default CrmReport;
